// @ts-nocheck
import * as React from "react";

const GlobeLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12.003 21a8.773 8.773 0 0 1-3.51-.709 9.095 9.095 0 0 1-2.859-1.922 9.081 9.081 0 0 1-1.925-2.857A8.752 8.752 0 0 1 3 12.003c0-1.244.236-2.414.708-3.51a9.096 9.096 0 0 1 1.923-2.859 9.081 9.081 0 0 1 2.857-1.925A8.752 8.752 0 0 1 11.997 3c1.244 0 2.414.236 3.51.708a9.096 9.096 0 0 1 2.859 1.923 9.082 9.082 0 0 1 1.925 2.857A8.752 8.752 0 0 1 21 11.997a8.772 8.772 0 0 1-.709 3.51 9.095 9.095 0 0 1-1.922 2.859 9.082 9.082 0 0 1-2.857 1.925 8.752 8.752 0 0 1-3.509.709ZM11 19.95V18c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 9 16v-1l-4.8-4.8c-.05.3-.096.6-.138.9-.041.3-.062.6-.062.9 0 2.017.662 3.783 1.987 5.3 1.325 1.517 2.996 2.4 5.013 2.65Zm6.9-2.55c.333-.367.633-.762.9-1.188.267-.425.488-.866.662-1.325.175-.458.309-.929.4-1.412.092-.483.138-.975.138-1.475a7.964 7.964 0 0 0-1.353-4.502A7.612 7.612 0 0 0 15 4.562V5c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 13 7h-2v2c0 .283-.096.52-.287.713A.968.968 0 0 1 10 10H8v2h6c.283 0 .52.096.713.287.191.192.287.43.287.713v3h1c.433 0 .825.13 1.175.387.35.259.592.596.725 1.013Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(GlobeLine);
